import { Component, Output } from '@angular/core';
import { IAbstractView } from '@core/interfaces';
import { ShoppingcartPresenter } from './shoppingcart.presenter';
import { IShoppingCartComponent, IShoppingCartPresenter } from './interfaces';
import { ICartItemChange } from '@shared/components/cart-items/interfaces';

@Component({
	selector: 'app-shoppingcart',
	templateUrl: './shoppingcart.component.html',
	styleUrls: ['./shoppingcart.component.scss'],
	providers: [ShoppingcartPresenter],
	standalone: false,
})
export class ShoppingcartComponent extends IAbstractView<IShoppingCartPresenter> implements IShoppingCartComponent {
	translations = this.presenter.translations;
	emptyCartImg = this.presenter.emptyCartImg;
	startOverImg = this.presenter.startOverImg;
	cardImg = this.presenter.startOverImg;
	showSummary = this.presenter.showSummary;
	auth$ = this.presenter.auth$;
	cartItems$ = this.presenter.cartItems$;
	cartTotals$ = this.presenter.cartTotals$;
	cartItemEmpty$ = this.presenter.cartItemEmpty$;
	shoppingCartHeader$ = this.presenter.shoppingCartHeader$;

	@Output() currentStep = this.presenter.currentStep;

	constructor(presenter: ShoppingcartPresenter) {
		super(presenter);
	}

	closeCart(): void {
		this.presenter.closeCart();
	}

	onItemDeleted(event: ICartItemChange): void {
		this.presenter.onItemDeleted(event);
	}

	changeAmount(event: ICartItemChange): void {
		this.presenter.changeAmount(event);
	}
}
